import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { paths } from '../../config/router.config';
import BillsView from './BillsView';

export default function BillsController(props){
    const {t} = useTranslation();
    const history = useHistory();

    const columns = [
        { field: 'id', name: '#', width: 50, sortable: false, align: 'center', alignHeader: 'center'},
        { field: 'number', name: 'Number', },
        { field: 'due_date', name: 'Due Date', },
        { field: 'from_date', name: 'From Date', },
        { field: 'to_date', name: 'To Date', },
        { field: 'status', name: 'Status', },
        { field: 'amount', name: 'Amount', },
    ];
    const rows = [
        { id: 1, number: 'B0000000529', due_date: '03/12/2021', from_date: '01/01/2022', to_date: '01/02/2022', status: 'Settled', amount: 0 },
        { id: 2, number: 'B0000000496', due_date: '21/11/2021', from_date: '01/12/2021', to_date: '01/02/2022', status: 'Settled', amount: 0 },
    ]

    const onDetail = (detail) => {
        console.log("detail===", detail);
        const rowsDetail = [
            { id: 'BASE-PREPAID-O-40-10', description: 'PREPAID 40MBPS', type: 'Debit', net_amout: 0, discount_amount: 0, discount: 0, tax_amount: 0, total: 0 },
        ]
        if(detail){
            history.push(paths.bill_detail, {detail: rowsDetail});
        }
    }

    return (
        <BillsView 
            columns={columns}
            rows={rows}
            onDetail={onDetail}
        />
    );
}